(function () {
    "use strict";

    /** Длительность анимации. */
    let transition = 300;

    /** Меню bootstrap. */
    (function () {
        /** Анимации меню bootstrap. */
        let menuItem = $("nav.navbar .dropdown");

        menuItem.on("mouseenter", function () {
            let menu = $(this).find("ul").eq(0);
            menu.stop().slideDown(transition);
        });
        menuItem.on("mouseleave", function () {
            let menu = $(this).find("ul").eq(0);
            menu.stop().slideUp(transition);
        });

        /** Элементы мобильного меню. */
        let menuToggle = $("nav.navbar i");
        let navbarToggle = $(".navbar-toggler");

        navbarToggle.on("click", function () {
            menuToggle.removeClass("icon-minus");
            menuToggle.addClass("icon-plus");
        });

        menuToggle.on("click", function (event) {
            let menu = $(this).siblings("ul"),
                nestedIcons = menu.find("i");

            if (event.target.className === "icon-plus") {
                menu.stop().slideDown(transition, function () {
                    $(this).css({height: "auto"});
                });
            } else {
                menu.stop().slideUp(transition, function () {
                    $(this).css({height: "auto"});
                });

                nestedIcons.removeClass("icon-minus");
                nestedIcons.addClass("icon-plus");
            }

            $(this).toggleClass("icon-plus icon-minus");
        })
    }());

    /** Анимация поиска. */
    (function () {
        let searchButton = $(".search-button"),
            icon = searchButton.find(".icon-angle-down");

        searchButton.on("click", function () {
            let searchForm = $(".search-form");

            if (searchForm.css("display") === "none") {
                searchForm.slideDown(transition);
                icon.attr("class", "icon-angle-up");
            } else {
                searchForm.slideUp(transition);
                icon.attr("class", "icon-angle-down");
            }
        });
    }());

    /** Переключение текста слайдера, при смене слайдера. */
    (function () {
        let sliderImg = $("#main-slider");
        let sliderText = $(".slider-index .cart");

        sliderImg.on("slide.bs.carousel", function (event) {
            sliderText.stop().fadeOut(800);
            sliderText.eq(event.to).stop().fadeIn(800);
        });

        sliderText.on("mouseenter", function () {
            sliderImg.carousel("pause");
        });
        sliderText.on("mouseleave", function () {
            sliderImg.carousel("cycle");
        })
    }());

    /** Кнопка возврата в начало страницы. */
    (function(){
        let toTop = $("#to-top");

        toTop.on('click', function(event){
            event.preventDefault();
            $('body,html').animate({scrollTop: 0}, transition);
        });
    }());

    /** Табы на главной внизу страницы. */
    (function () {
        let tabsBody = $(".tabs-bottom-page"),
            labels = tabsBody.find(".label").find("a"),
            allCarts = tabsBody.find(".tab-body");

        labels.on("click", function (event) {
            event.preventDefault();
            let id = $(this).attr("href"),
                currentCart = $(id);

            labels.removeClass("active");
            $(this).addClass("active");

            allCarts.removeClass("active");
            currentCart.addClass("active");
        });
    }());

    /** Валидация комментариев */
    (function () {
        let form = $("#comment-form"),
            reCaptcha = form.find(".field-comment-recaptcha"),
            submit = form.find(".comment-submit"),
            helpBlock = form.find(".field-comment-recaptcha .help-block");

        submit.on("click", function () {
            if (helpBlock.text() !== "") {
                reCaptcha.addClass("error-border");
            } else {
                reCaptcha.removeClass("error-border");
            }
        })
    }());

    /** Развернуть/свернуть вложенный пункт бокового меню. */
    (function() {
        let toggle = $(".side-bar .toggle-display");

        showFullPath();

        toggle.on("click", function () {
            let currentUl = $(this).siblings("ul");

            if ($(this).hasClass("icon-plus")) {
                currentUl.stop().slideDown(transition);
                currentUl.addClass("show");
            } else {
                currentUl.stop().slideUp(transition);
                currentUl.removeClass("show");
            }

            $(this).toggleClass("icon-plus icon-minus");
        });

        /** Разворнуть все вложенные категории, в которых находится активный пункт меню. */
        function showFullPath() {
            let sideBar = $(".side-bar"),
                active = sideBar.find(".active"),
                parentsUl = active.parents("ul"),
                parentsA = parentsUl.siblings("a"),
                parentsIcon = parentsUl.siblings("i");

            parentsA.addClass("active");
            parentsUl.addClass("show");
            parentsIcon.removeClass("icon-plus").addClass("icon-minus");
        }
    }());

    /** Вставка iframe youtube. По нажатию на изображение оно заменяется iframe с автовоспроизведением. */
    (function() {
        let urlIframe = $(".img-youtube");

        urlIframe.each(function () {
            let srcImg = $(this).data("img"),
                srcIframe = $(this).data("link"),
                qualityThumbnail;

            $(this).html(`
                <img class="img-main img-fluid" data-src="${srcImg}" alt="">
                <span class="youtube">
                    <span class="button-youtube">
                        <img data-src="/image/youtube-play.png" alt="">
                    </span>
                </span>
            `);

            $(this).on("click" ,function () {
                let iframe,
                    imgMain = $(this).find(".img-main"),
                    imgMainAfter = $(this).find(".youtube"),
                    imgWidth = imgMain.width().toFixed() + "px",
                    imgHeight = imgMain.height().toFixed() + "px";

                $(this).html(`
                    <iframe width="${imgWidth}" height="${imgHeight}" src="${srcIframe}?enablejsapi=1&autoplay=1&mute=0" 
                    frameborder="0" allowfullscreen></iframe>
                `);

                iframe = this.querySelector("iframe");

                setTimeout(function () {
                    iframe.contentWindow.postMessage('{"event":"command","func":"mute","args":""}', '*');
                    iframe.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
                }, 700);
            })
        });
    }());

    /** Параметры lazy-load. */
    (function () {
        $.extend($.lazyLoadXT, {
            edgeY:  600,
        });
    }());
}());